module.exports = __webpack_public_path__ + "19_tvcg.jpg?8e65a22a5041c248d7cdd22f6b8c6284";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/19_tvcg.jpg
// module id = 168
// module chunks = 0